"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextSwitcherMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("./common");
const ContextSwitcherMobile = ({ appContext, availableContexts, onCtxChange }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const onWindowClick = (e) => {
        if (!e.target.closest(".switcher-mobile")) {
            setIsOpen(false);
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener("click", onWindowClick);
        return () => {
            window.removeEventListener("click", onWindowClick);
        };
    }, []);
    const opts = common_1.options.filter((opt) => opt.value !== appContext && availableContexts.includes(opt.value));
    const activeCtx = common_1.options.find((opt) => opt.value === appContext);
    const toggleDisplayOptions = () => {
        // eslint-disable-next-line no-constant-condition
        if (true) {
            return;
        }
    };
    const onOptionClick = (ctx) => () => {
        toggleDisplayOptions();
        onCtxChange(ctx);
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { className: "switcher-mobile", children: [(0, jsx_runtime_1.jsx)("div", { onClick: toggleDisplayOptions, children: activeCtx === null || activeCtx === void 0 ? void 0 : activeCtx.body }, void 0), (0, jsx_runtime_1.jsx)("div", { children: isOpen && opts.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [opts.map((opt) => {
                            return ((0, jsx_runtime_1.jsx)("div", { onClick: onOptionClick(opt.value), children: opt.body }, opt.value));
                        }), (0, jsx_runtime_1.jsx)("div", {}, void 0)] }, void 0)) }, void 0)] }, void 0));
};
exports.ContextSwitcherMobile = ContextSwitcherMobile;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  position: relative;

  & > div:first-of-type {
    padding: 1rem;
  }

  & > div:last-of-type {
    & > div {
      position: absolute;
      z-index: 20;
    }

    & > div:not(:last-of-type) {
      background-color: ${({ theme }) => theme.colors.silverBase};
      padding: 1rem;
    }

    & > div:last-of-type {
      background-image: linear-gradient(
        rgba(30, 33, 32, 0.08),
        rgba(30, 33, 32, 0)
      );
      height: 5rem;
      top: calc(11rem - 2px);
      pointer-events: none;
      width: 100%;
    }
  }

  @media (min-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    display: none;
  }
`;
//# sourceMappingURL=ContextSwitcherMobile.js.map